export const updatePaymentStatusIntervalInMilliseconds = 1000;
export const paymentStatusUpdateMaxTimeInMilliseconds = 120000;
export const automaticSubmitPaymentOrderAfterMilliseconds = 4000;
